import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/sales/quotes/$id')({
  component: SalesQuoteIdLayout,
});

function SalesQuoteIdLayout() {
  return <Outlet />;
}
